<template>
  <footer id="footer" class="footer">
    <Container>
      <div class="footer-top">
        <div class="footer-brand">
          <img src="@/assets/logo_new.png" alt="Deyoke Foods" class="footer-logo" />
          <p>
            Premium organic turkey berry powder and tea, crafted from farm to
            table for a healthier everyday.
          </p>
        </div>

        <div class="footer-col">
          <h4>Quick Links</h4>
          <a href="#home">Home</a>
          <a href="#about">About Us</a>
          <a href="#products">Products</a>
          <a href="#team">Team</a>
          <a href="#faq">FAQ</a>
        </div>

        <div class="footer-col">
          <h4>Legal</h4>
          <a href="#">Privacy Policy</a>
          <a href="#">Privacy Settings</a>
          <a href="#">Advertising Policy</a>
          <a href="#">Health Topics</a>
        </div>

        <div class="footer-col">
          <h4>Contact Us</h4>
          <a href="tel:+233544546153">+233 544 546 153</a>
          <a href="tel:+233508746143">+233 508 746 143</a>
          <a href="mailto:deyoke.foods24@gmail.com">deyoke.foods24@gmail.com</a>
          <p>P. O. Box 2242, Sunyani</p>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; {{ year }} Deyoke Foods. All rights reserved.</p>
      </div>
    </Container>
  </footer>
</template>

<script setup>
import Container from "@/components/Container/Container.vue"

const year = new Date().getFullYear()
</script>

<style scoped>
.footer {
  background: var(--primary-900);
  padding-top: 4.5rem;
  color: rgba(255, 255, 255, 0.65);
}

.footer-top {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1.2fr;
  gap: 2.5rem;
  padding-bottom: 3rem;
}

.footer-logo {
  width: 130px;
  margin-bottom: 1rem;
}

.footer-brand p {
  font-size: 0.88rem;
  line-height: 1.7;
  max-width: 260px;
}

.footer-col h4 {
  font-family: var(--font-heading);
  color: #fff;
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 1.25rem;
}

.footer-col {
  display: flex;
  flex-direction: column;
}

.footer-col a,
.footer-col p {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
  transition: color var(--transition);
  width: fit-content;
}

.footer-col a:hover {
  color: var(--accent);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 1.75rem 0;
  text-align: center;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 1023px) {
  .footer-top {
    grid-template-columns: 1fr 1fr;
    row-gap: 2.5rem;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-brand p {
    max-width: 100%;
  }
}

@media (max-width: 640px) {
  .footer {
    padding-top: 3rem;
    text-align: center;
  }

  .footer-top {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-logo {
    margin: 0 auto 1rem;
  }

  .footer-brand p {
    margin: 0 auto;
  }

  .footer-col a,
  .footer-col p {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
